{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Doorverbinden met een medewerker",
    "MESSAGE": "Verbind me door met een medewerker"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Downloaden",
      "UPLOADING": "Uploaden..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Bevestigen"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Bericht opnieuw verzenden",
      "ERROR_MESSAGE": "Verzenden mislukt, probeer het opnieuw"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Beoordeel de kwaliteit van dit antwoord"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Wacht tot een agent deelneemt"
  },
  "ROBOT_CHECK": {
    "TITLE": "Snelle beveiligingscontrole",
    "DESCRIPTION": "Voltooi de onderstaande controle.",
    "VERIFYING": "Verifiëren…",
    "ERROR": "Dat is niet gelukt. Probeer het opnieuw.",
    "RETRY": "Probeer opnieuw"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "We zijn online",
    "OFFLINE": "We zijn momenteel afwezig",
    "ONLINE_WITH_BOT": "Het team en onze AI-assistent zijn online",
    "OFFLINE_WITH_BOT": "Onze AI-assistent is hier om te helpen",
    "BOT_ONLY_REPLY": "Reageert onmiddellijk"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Reageert meestal binnen een paar minuten",
    "IN_A_FEW_HOURS": "Reageert meestal binnen een paar uur",
    "IN_A_DAY": "Reageert meestal binnen een dag",
    "BACK_IN": "We zullen weer online zijn"
  },
  "DAY_NAMES": {
    "SUNDAY": "zondag",
    "MONDAY": "maandag",
    "TUESDAY": "dinsdag",
    "WEDNESDAY": "woensdag",
    "THURSDAY": "donderdag",
    "FRIDAY": "vrijdag",
    "SATURDAY": "zaterdag"
  },
  "START_CONVERSATION": "Start Chat",
  "END_CONVERSATION": "Gesprek beëindigen",
  "CONTINUE_CONVERSATION": "Verdergaan met gesprek",
  "YOU": "Jij",
  "START_NEW_CONVERSATION": "Een nieuw gesprek starten",
  "RESOLVE_LATER": "We lossen dit onderwerp op via e-mail/telefoon. Ik wil nu over iets anders vragen.",
  "VIEW_UNREAD_MESSAGES": "Je hebt ongelezen berichten",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Bekijk nieuwe berichten",
    "CLOSE_MESSAGES_BUTTON": "Sluiten",
    "COMPANY_FROM": "van",
    "BOT": "Robot"
  },
  "BUBBLE": {
    "LABEL": "Chat met ons"
  },
  "POWERED_BY": "Mogelijk gemaakt door {brandName}",
  "EMAIL_PLACEHOLDER": "Voer uw e-mailadres in",
  "CHAT_PLACEHOLDER": "Typ uw bericht",
  "TODAY": "Vandaag",
  "YESTERDAY": "Gisteren",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Volledige Naam",
        "PLACEHOLDER": "Voer uw volledige naam in",
        "REQUIRED_ERROR": "Volledige naam is vereist"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Uw e-mailadres",
        "PLACEHOLDER": "Voer uw e-mailadres in",
        "REQUIRED_ERROR": "E-mailadres is vereist",
        "VALID_ERROR": "Voer een geldig e-mailadres in"
      },
      "PHONE_NUMBER": {
        "LABEL": "Telefoonnummer",
        "PLACEHOLDER": "Vul je telefoonnummer in",
        "REQUIRED_ERROR": "Telefoon nummer is vereist",
        "DIAL_CODE_VALID_ERROR": "Selecteer alstublieft een landcode",
        "VALID_ERROR": "Voer een geldig telefoonnummer in",
        "DROPDOWN_EMPTY": "Geen resultaten gevonden",
        "DROPDOWN_SEARCH": "Land zoeken"
      },
      "MESSAGE": {
        "LABEL": "Bericht",
        "PLACEHOLDER": "Voer uw bericht in",
        "ERROR": "Bericht te kort"
      }
    },
    "CAMPAIGN_HEADER": "Geef uw naam en e-mail voordat u het gesprek begint",
    "IS_REQUIRED": "is vereist",
    "REQUIRED": "Vereist",
    "REGEX_ERROR": "Voer een geldige waarde in"
  },
  "FILE_SIZE_LIMIT": "Bestand overschrijdt de bijlagelimiet van {MAXIMUM_FILE_UPLOAD_SIZE}",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Ongeldig veld"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Zoek emojis",
    "NOT_FOUND": "Er zijn geen overeenkomende emoji's gevonden",
    "ARIA_LABEL": "Emoji-kiezer"
  },
  "CSAT": {
    "TITLE": "Beoordeel uw gesprek",
    "SUBMITTED_TITLE": "Bedankt voor het indienen van een beoordeling",
    "PLACEHOLDER": "Vertel ons meer..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Verzoek een conversatie-transcript",
    "SEND_EMAIL_SUCCESS": "Het gesprekstranscript is succesvol verzonden",
    "SEND_EMAIL_ERROR": "Er is een fout opgetreden, probeer het opnieuw"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Populaire artikelen",
    "VIEW_ALL_ARTICLES": "Bekijk alle artikelen",
    "IFRAME_LOAD_ERROR": "Er is een fout opgetreden bij het laden van het artikel, ververs de pagina en probeer het opnieuw."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Openen",
      "BUY": "Kopen"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Bericht met foto"
    },
    "audio": {
      "CONTENT": "Audiobericht"
    },
    "video": {
      "CONTENT": "Videobericht"
    },
    "file": {
      "CONTENT": "Bestandsbijlage"
    },
    "location": {
      "CONTENT": "Locatie"
    },
    "fallback": {
      "CONTENT": "heeft een url gedeeld"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Antwoord op:"
  }
}
